export const CONTENT_BASE_FONT_NAME = 'Open Sans';
export const ICONS_FONT_NAME        = 'Eikaiwa Icons';
export const FALLBACK               = 'sans-serif';

export const CORE_FONTS = [
  CONTENT_BASE_FONT_NAME,
  ICONS_FONT_NAME,
];

export const FALLBACK_FONTS = [
  FALLBACK,
];

export const BASE_FONT_NAMES = [
  ...CORE_FONTS,
  ...FALLBACK_FONTS,
];

export const MONOSPACE_FONTS = [
  'Menlo', // Apple
  'Consolas', // Windows
  'Monaco', // old Apple
  'Roboto Mono', // Android
  'Droid Sans Mono', // old Android
  'Fira Mono', // Firefox OS
  'Bitstream Vera Sans Mono', // included in many OSs
  'monospace',
];

export const EIKAIWA_ICON_BLANK = String.fromCharCode(0xe900);
